import { isPlatformServer } from '@angular/common';
import { PLATFORM_ID, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { REQUEST, RESPONSE } from 'src/express.tokens';
import { routes } from 'utils/routes';
import { SlugLandGQL } from './slug.query.generated';

export const landSlugGuard: CanActivateFn = (route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
  const query = inject(SlugLandGQL);
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);
  const request = isPlatformServer(platformId) ? inject(REQUEST) : null;
  const response = isPlatformServer(platformId) ? inject(RESPONSE) : null;
  const slug = route.params['slug'];
  if (slug) {
    return query.fetch({ slug }, { fetchPolicy: 'network-only' }).pipe(
      map(r => {
        if (slug !== r.data?.landBySlug?.slug && isPlatformServer(platformId)) {
          if (response) {
            response.redirect(
              301,
              routes[request.i18n?.language as 'it']['routes.land'] + '/' + r.data?.landBySlug?.slug,
            );
          }
        }
        if (r.data?.landBySlug?.id) {
          const deployed = !!r.data?.landBySlug?.deployed;
          if (deployed) {
            return true;
          }
          return router.parseUrl('/not-found');
        } else {
          return router.parseUrl('/not-found');
        }
      }),
      catchError(() => of(router.parseUrl('/not-found'))),
    );
  } else {
    return router.parseUrl('/not-found');
  }
};
